import VS from 'constants/ValidationShema';
import InputLimits from 'constants/InputLimits';
import Tr from 'translations/Translations';
import {isEuropeProcedure, isNonpublicProcedure, isNationalProcedure} from "constants/ProcedureType";
import {isDemandPreparing} from "libs/getDemandStatus";

const inputLimits = InputLimits.procedure.basicInformation;

export default (demandRealizationTypes, numberAutomated, caseClassificationSymbolRequired) => {
    return VS.lazy((values) => {
        const passiveOfferForm = values.passiveOfferForm;
        const euFunded = values.euFunded;
        const procedureType = values.procedureType;
        const realizationType = values.demandRealizationType;
        const europeProcedure = isEuropeProcedure(procedureType);
        const nonpublicProcedure = isNonpublicProcedure(procedureType);
        const nationalProcedure = isNationalProcedure(procedureType);
        const withNotice = realizationType ? demandRealizationTypes.find(x => x.name === realizationType).withNotice : false;
        const creatingDemand = values.identity <= 0 || isDemandPreparing();

        let baseObj = {
            number: VS.any().when("name", {is: (x) => numberAutomated === true, then: VS.any(), otherwise: VS.stringMax(inputLimits.NUMBER)}),
            demandCategoryType: creatingDemand ? VS.string() : VS.any(),
            name: VS.stringMax(inputLimits.NAME),
            description: VS.stringMax(inputLimits.DESCRIPTION),
            formType: withNotice ? VS.string() : VS.any(),
            demandRealizationType: VS.string(),
            primaryTenderVariant: nationalProcedure ? VS.string() : VS.stringNoRq(),
            demandOrderType: VS.string(),
            categoryItemCpv: VS.arrayRequired(),

            contactPerson: VS.stringMaxNoRq(inputLimits.CONTACT_PERSON),

            contactPersonPhone: VS.stringMaxNoRq(inputLimits.CONTACT_PERSON_PHONE),
            contactPersonEmail: VS.emailMaxNoRq(inputLimits.PURCHASER_EMAIL),
            purchaserPhone: VS.stringMaxNoRq(inputLimits.PURCHASER_PHONE),
            purchaserFax: VS.stringMaxNoRq(inputLimits.PURCHASER_FAX),

            purchaserEmail: VS.emailMaxNoRq(inputLimits.PURCHASER_EMAIL),
            purchaserAdditionalInfo: VS.stringMaxNoRq(inputLimits.PURCHASER_ADDITIONAL_INFO),

            euProjectNumber: euFunded === "true" && VS.stringMax(inputLimits.EU_PROJECT_NUMBER),
            caseClassificationSymbol: VS.any().when("name", {is: (x) => caseClassificationSymbolRequired === true, then: VS.string(), otherwise: VS.any()})
        }

        if (europeProcedure) {
            baseObj.requiredJEDZ = VS.string();
        }
        if (nonpublicProcedure) {
            baseObj.pzpExclusion = VS.stringNoRq();
        }

        baseObj.demandVariant = VS.string()

        if (passiveOfferForm) {
            return VS.object(baseObj)
        }

        // if (values.termOption === 'date') {
        //     baseObj['termDate'] = VS.dateMinNoRq(new Date(), Tr("v_data_can_not_be_past"))
        // }

        baseObj = {
            ...baseObj,

            auctionMade: VS.string(),
            digitalSign: VS.string(),
            priceType: VS.string(),

            externalPurchaseRequestNumber: VS.stringMaxNoRq(inputLimits.EOD),
            singleDealingJustification: VS.stringMaxNoRq(inputLimits.SINGLE_DEALING_JUSTIFICATION),
            estimationBase: VS.stringMaxNoRq(inputLimits.ESTIMATION_BASE),
            financialSource: VS.stringMaxNoRq(inputLimits.FINANCIAL_SOURCE),
            termDescription: VS.stringMaxNoRq(inputLimits.TERM_DESCRIPTION),
            orderValueDecisionDate: VS.dateMaxNoRq(new Date(), Tr('v_data_can_not_be_future')),
            fullNameOrderValueDecisionPerson: VS.stringMaxNoRq(inputLimits.FULL_NAME),
            managerEntrustedPerson: VS.stringMaxNoRq(inputLimits.FULL_NAME),
        }

        return VS.object(baseObj)
    })
}